export default __webpack_public_path__ + "static/media/RENIFER.82ce6089.png";